module.exports = "<template> <div class=tyl-footer-item part=root> <slot></slot> </div> </template>";